<template>
  <TColorPicker
    :default-color="defaultColor"
    :label="label"
    :with-input="withInput"
    :position="position"
    :color-picker-top="colorPickerTop"
    :no-border-right="noBorderRight"
    :short="short"
    :no-input="noInput"
    :disabled="disabled"
    :colors="colors"
    :light="generalStore.light"
    :template-colors="templateColorsRef"
    :template-colors-label="$t('color_picker.template_colors')"
    :predefined-colors-label="$t('color_picker.predefined_colors')"
    :changed="changed"
    :reset-tooltip="resetTooltip"
    @color-change="emits('color-change', $event)"
    @get-template-colors="setColorsUsedInTemplate()"
    @start-selecting-color="generalStore.colorSelecting = true"
    @stop-selecting-color="generalStore.colorSelecting = false"
    @reset="emits('reset')"
  />
</template>

<script setup lang="ts">
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { useColorsStore } from "@/stores/colors";
  import { useGeneralStore } from "@/stores/generalStore";
  import { TColorPicker } from "@topol/twig-ui";
  import { computed, ref } from "vue";

  type Props = {
    defaultColor?: string;
    label?: string;
    withInput?: boolean;
    position?: string;
    colorPickerTop?: boolean;
    noBorderRight?: boolean;
    short?: boolean;
    noInput?: boolean;
    disabled?: boolean;
    changed?: boolean;
    resetTooltip?: string;
  };

  withDefaults(defineProps<Props>(), {
    defaultColor: undefined,
    label: "",
    withInput: true,
    position: "left",
    colorPickerTop: false,
    noBorderRight: false,
    short: false,
    noInput: false,
    disabled: false,
    changed: false,
    resetTooltip: undefined,
  });

  const emits = defineEmits(["color-change", "reset"]);

  const mjmlStore = useMjmlStore();
  const colorsStore = useColorsStore();
  const generalStore = useGeneralStore();

  const colors = computed(() => colorsStore.colors);
  const templateColorsRef = ref<string[]>(getAllColorsFromTemplate());

  const templateColors = computed({
    get() {
      return templateColorsRef.value;
    },
    set(value) {
      templateColorsRef.value = value;
    },
  });

  function getAllColorsFromTemplate() {
    const templateString = JSON.stringify(mjmlStore.getMjml()).toLowerCase();
    const hexColorPattern = /#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/g;
    const colors = templateString.match(hexColorPattern);
    return [...new Set(colors)];
  }

  function setColorsUsedInTemplate() {
    templateColors.value = getAllColorsFromTemplate();
  }
</script>
